import React from "react";
import { Button } from "Application";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { observer } from "mobx-react-lite";
import { WarningModal } from "Views/Students/Shared/Modals/WarningModal";
import { FixedActionButtons } from "Components/FixedActionButtons";

export const SessionReportFooter: React.FC<{ viewModel: IStudentSessionReportViewModel }> = observer(({ viewModel }) => {
    const showExportButton = !viewModel.showExport && viewModel.exportReportCommand;
    return (
        <>
            <FixedActionButtons>
                <Button
                    command={viewModel.upsertStudentSessionCommand}
                    displayName={viewModel.upsertButtonDisplayName}
                    className={viewModel.apiClient.IsBusy ? "isButtonDisable" : "add-another"}
                    paletteColor="primary"
                    animate={viewModel.isUpserting}
                />
                {showExportButton && (
                    <Button
                        command={viewModel.exportReportCommand!}
                        paletteColor="primary"
                        className="add-another"
                        animate={viewModel.isExporting}
                        displayName={viewModel.exportButtonDisplayName ?? "Export"}
                    />
                )}
                <Button
                    command={viewModel.navigateToBackCommand}
                    displayName={"CANCEL"}
                    paletteColor="secondary"
                    className={viewModel.apiClient.IsBusy ? "isButtonDisable" : "add-another"}
                />
            </FixedActionButtons>
            <WarningModal
                isOpen={viewModel.showFormErrorWarning}
                onClose={viewModel.dismissFormHasErrorsWarningCommand}
                onCloseButtonText="Close"
                warningMessage={viewModel.formErrorMessage!}
            />
            <WarningModal
                isOpen={viewModel.showCancelUpdateWarningMessage}
                onClose={viewModel.dismissCancelUpdateWarningCommand}
                onCloseButtonText="Cancel"
                onConfirmButtonText="Confirm"
                onConfirm={viewModel.confirmNavigateToStudentSessionsListCommand}
                warningMessage={viewModel.cancelUpdateWarningMessage!}
            />
        </>
    );
});
